const firebaseConfig = {
  apiKey: "AIzaSyBdkFHSo4e-CX8LCcNwaYIkSzQd9HuFfak",
  authDomain: "bookroom-bf3a0.firebaseapp.com",
  databaseURL: "https://bookroom-bf3a0.firebaseio.com",
  projectId: "bookroom-bf3a0",
  storageBucket: "bookroom-bf3a0.appspot.com",
  messagingSenderId: "214799869192",
  appId: "1:214799869192:web:35307a285838e051ceb8bd"
};
exports.config = firebaseConfig;



// WEBPACK FOOTER //
// ./src/config/firebase_config.js